import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchHelperService {
  private searchPanelSubject = new BehaviorSubject(false);
  searchPanel$ = this.searchPanelSubject.asObservable();

  private searchPanelKeywordSubject = new BehaviorSubject(null);
  searchPanelKeyword$ = this.searchPanelKeywordSubject.asObservable();

  private onSearchSubject = new BehaviorSubject(false);
  onSearch$ = this.onSearchSubject.asObservable();

  private openFilterSearchSubject = new BehaviorSubject(false);
  openFilterSearch$ = this.openFilterSearchSubject.asObservable();

  setopenFilterSearch(state = true) {
    this.openFilterSearchSubject.next(state);
  }

  openSearchSidebar(state = true) {
    this.searchPanelSubject.next(state);
  }

  openSearchSidebarKeyword(state = true, keyword: any | null) {
    this.searchPanelSubject.next(state);
    this.searchPanelKeywordSubject.next(keyword);
  }

  setOnSearch(state = true) {
    this.onSearchSubject.next(state);
  }
}
